import type { RoleAssignmentType as RoleAssignmentTypeModel } from '@/adapters/catalogv1.g';

export function extractRoleAssignmentType(model: RoleAssignmentTypeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    roleRef: model.role_ref ?? '',
    assignmentType: model.assignment_type ?? '',
    memberType: model.member_type ?? '',
    scopeRef: model.scope_ref ?? '',
    startsAt: model.starts_at ?? '',
    expiresAt: model.expires_at ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogRoleAssignmentType = ReturnType<
  typeof extractRoleAssignmentType
>;
